import { render } from "./dashboards.vue?vue&type=template&id=5a3ea5fe&scoped=true"
import script from "./dashboards.vue?vue&type=script&lang=js"
export * from "./dashboards.vue?vue&type=script&lang=js"

import "./dashboards.vue?vue&type=style&index=0&id=5a3ea5fe&lang=scss"
import "./dashboards.vue?vue&type=style&index=1&id=5a3ea5fe&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3ea5fe"]])

export default __exports__